export const tr = {
    'add-creatives': 'Seçilen öğeleri ekle',
    campaigns: 'Kampanyalar',
    'campaigns-dropdown-label': 'Şunu kullanan kampanyalar',
    'campaigns-not-found': 'Kampanya bulunamadı',
    'cancel-and-return': 'İptal',
    create: 'Şunun bazında oluştur',
    'create-new': 'oluştur',
    'get-link-dropdown-label': 'Bağlantı al',
    'items-not-found': 'Bu alan şimdilik boş; bir şeyler {presetsLink} tam zamanı',
    preview: 'Göster',
    'rename-label': 'Yeniden isimlendir',
    'search-placeholder': 'Bul',
    'show-linked-only': 'Sadece reklamlara bağlı olan kreatifleri göster',
    'sound-setting': 'Sesi oynat'
};
